module.exports = {
	"ha": "nha",
	"id": 5.5,
	"report": {
		"ha": "Northern Health",
		"group": "HSDA",
		"period": "2019 Q1–2020 Q4",
		"lastYear": "2020",
		"lastQuarter": "4"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 80,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.5</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Northern Health by Age Category and MSM Status, Year Ending 2020 Q4 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -100,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "50%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "50%",
				"height": "50%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -100,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "5"
						},
						"color": "#043f61"
					},
					{
						"y": 80,
						"dataLabels": {
							"enabled": false,
							"format": "4"
						},
						"color": "#0c4250"
					},
					{
						"y": 80,
						"dataLabels": {
							"enabled": false,
							"format": "4"
						},
						"color": "#0d4440"
					},
					{
						"y": 80,
						"dataLabels": {
							"enabled": false,
							"format": "4"
						},
						"color": "#09472e"
					},
					{
						"y": 60,
						"dataLabels": {
							"enabled": false,
							"format": "3"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "5"
						},
						"color": "#043f61"
					},
					{
						"y": 60,
						"dataLabels": {
							"enabled": false,
							"format": "3"
						},
						"color": "#0c4250"
					},
					{
						"y": 60,
						"dataLabels": {
							"enabled": false,
							"format": "3"
						},
						"color": "#0d4440"
					},
					{
						"y": 60,
						"dataLabels": {
							"enabled": false,
							"format": "3"
						},
						"color": "#09472e"
					},
					{
						"y": 40,
						"dataLabels": {
							"enabled": false,
							"format": "2"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 88.88888888888889,
						"dataLabels": {
							"enabled": false,
							"format": "8"
						},
						"color": "#043f61"
					},
					{
						"y": 77.77777777777779,
						"dataLabels": {
							"enabled": false,
							"format": "7"
						},
						"color": "#0c4250"
					},
					{
						"y": 66.66666666666666,
						"dataLabels": {
							"enabled": false,
							"format": "6"
						},
						"color": "#0d4440"
					},
					{
						"y": 44.44444444444444,
						"dataLabels": {
							"enabled": false,
							"format": "4"
						},
						"color": "#09472e"
					},
					{
						"y": 11.11111111111111,
						"dataLabels": {
							"enabled": false,
							"format": "1"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.29629629629629,
						"dataLabels": {
							"enabled": false,
							"format": "26"
						},
						"color": "#043f61"
					},
					{
						"y": 70.37037037037037,
						"dataLabels": {
							"enabled": false,
							"format": "19"
						},
						"color": "#0c4250"
					},
					{
						"y": 70.37037037037037,
						"dataLabels": {
							"enabled": false,
							"format": "19"
						},
						"color": "#0d4440"
					},
					{
						"y": 66.66666666666666,
						"dataLabels": {
							"enabled": false,
							"format": "18"
						},
						"color": "#09472e"
					},
					{
						"y": 44.44444444444444,
						"dataLabels": {
							"enabled": false,
							"format": "12"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "9"
						},
						"color": "#043f61"
					},
					{
						"y": 66.66666666666666,
						"dataLabels": {
							"enabled": false,
							"format": "6"
						},
						"color": "#0c4250"
					},
					{
						"y": 55.55555555555556,
						"dataLabels": {
							"enabled": false,
							"format": "5"
						},
						"color": "#0d4440"
					},
					{
						"y": 33.33333333333333,
						"dataLabels": {
							"enabled": false,
							"format": "3"
						},
						"color": "#09472e"
					},
					{
						"y": 11.11111111111111,
						"dataLabels": {
							"enabled": false,
							"format": "1"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "25"
						},
						"color": "#043f61"
					},
					{
						"y": 80,
						"dataLabels": {
							"enabled": false,
							"format": "20"
						},
						"color": "#0c4250"
					},
					{
						"y": 80,
						"dataLabels": {
							"enabled": false,
							"format": "20"
						},
						"color": "#0d4440"
					},
					{
						"y": 68,
						"dataLabels": {
							"enabled": false,
							"format": "17"
						},
						"color": "#09472e"
					},
					{
						"y": 20,
						"dataLabels": {
							"enabled": false,
							"format": "5"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 97.91666666666666,
						"dataLabels": {
							"enabled": false,
							"format": "47"
						},
						"color": "#043f61"
					},
					{
						"y": 93.75,
						"dataLabels": {
							"enabled": false,
							"format": "45"
						},
						"color": "#0c4250"
					},
					{
						"y": 89.58333333333334,
						"dataLabels": {
							"enabled": false,
							"format": "43"
						},
						"color": "#0d4440"
					},
					{
						"y": 68.75,
						"dataLabels": {
							"enabled": false,
							"format": "33"
						},
						"color": "#09472e"
					},
					{
						"y": 18.75,
						"dataLabels": {
							"enabled": false,
							"format": "9"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "92"
						},
						"color": "#043f61"
					},
					{
						"y": 88.04347826086956,
						"dataLabels": {
							"enabled": false,
							"format": "81"
						},
						"color": "#0c4250"
					},
					{
						"y": 84.78260869565217,
						"dataLabels": {
							"enabled": false,
							"format": "78"
						},
						"color": "#0d4440"
					},
					{
						"y": 81.52173913043478,
						"dataLabels": {
							"enabled": false,
							"format": "75"
						},
						"color": "#09472e"
					},
					{
						"y": 41.30434782608695,
						"dataLabels": {
							"enabled": false,
							"format": "38"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 50,
						"dataLabels": {
							"enabled": false,
							"format": "6"
						},
						"color": "#043f61"
					},
					{
						"y": 41.66666666666667,
						"dataLabels": {
							"enabled": false,
							"format": "5"
						},
						"color": "#0c4250"
					},
					{
						"y": 41.66666666666667,
						"dataLabels": {
							"enabled": false,
							"format": "5"
						},
						"color": "#0d4440"
					},
					{
						"y": 41.66666666666667,
						"dataLabels": {
							"enabled": false,
							"format": "5"
						},
						"color": "#09472e"
					},
					{
						"y": 8.333333333333332,
						"dataLabels": {
							"enabled": false,
							"format": "1"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "12"
						},
						"color": "#043f61"
					},
					{
						"y": 75,
						"dataLabels": {
							"enabled": false,
							"format": "9"
						},
						"color": "#0c4250"
					},
					{
						"y": 75,
						"dataLabels": {
							"enabled": false,
							"format": "9"
						},
						"color": "#0d4440"
					},
					{
						"y": 58.333333333333336,
						"dataLabels": {
							"enabled": false,
							"format": "7"
						},
						"color": "#09472e"
					},
					{
						"y": 33.33333333333333,
						"dataLabels": {
							"enabled": false,
							"format": "4"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 93.75,
						"dataLabels": {
							"enabled": false,
							"format": "15"
						},
						"color": "#043f61"
					},
					{
						"y": 75,
						"dataLabels": {
							"enabled": false,
							"format": "12"
						},
						"color": "#0c4250"
					},
					{
						"y": 68.75,
						"dataLabels": {
							"enabled": false,
							"format": "11"
						},
						"color": "#0d4440"
					},
					{
						"y": 50,
						"dataLabels": {
							"enabled": false,
							"format": "8"
						},
						"color": "#09472e"
					},
					{
						"y": 37.5,
						"dataLabels": {
							"enabled": false,
							"format": "6"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 91.66666666666666,
						"dataLabels": {
							"enabled": false,
							"format": "44"
						},
						"color": "#043f61"
					},
					{
						"y": 70.83333333333334,
						"dataLabels": {
							"enabled": false,
							"format": "34"
						},
						"color": "#0c4250"
					},
					{
						"y": 68.75,
						"dataLabels": {
							"enabled": false,
							"format": "33"
						},
						"color": "#0d4440"
					},
					{
						"y": 60.416666666666664,
						"dataLabels": {
							"enabled": false,
							"format": "29"
						},
						"color": "#09472e"
					},
					{
						"y": 35.41666666666667,
						"dataLabels": {
							"enabled": false,
							"format": "17"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.999999999999996,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -40,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -33.333333333333336,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -11.111111111111116,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.5,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.28571428571429,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -33.333333333333336,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -75,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.703703703703709,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -26.923076923076927,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.263157894736848,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -33.333333333333336,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -33.333333333333336,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.666666666666664,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -40,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -66.66666666666667,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.999999999999996,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -15.000000000000002,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -70.58823529411764,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.083333333333337,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.255319148936165,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.444444444444439,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -23.25581395348837,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -72.72727272727273,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.956521739130432,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.703703703703709,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.8461538461538436,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -49.33333333333333,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": -50,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.666666666666664,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -80,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -22.22222222222222,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -42.85714285714286,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -6.25,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.999999999999996,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.333333333333337,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -27.27272727272727,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -8.333333333333337,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -22.72727272727273,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.941176470588236,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.121212121212121,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -41.379310344827594,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 12,
				"y": 40,
				"text": "MSM"
			},
			{
				"x": 3,
				"text": "<30<br>n=5"
			},
			{
				"x": 9,
				"text": "30-39<br>n=5"
			},
			{
				"x": 15,
				"text": "40-49<br>n=9"
			},
			{
				"x": 21,
				"text": ">=50<br>n=27"
			},
			{
				"x": 37,
				"y": 40,
				"text": "Non-MSM"
			},
			{
				"x": 28,
				"text": "<30<br>n=9"
			},
			{
				"x": 34,
				"text": "30-39<br>n=25"
			},
			{
				"x": 40,
				"text": "40-49<br>n=48"
			},
			{
				"x": 46,
				"text": ">=50<br>n=92"
			},
			{
				"x": 62,
				"y": 40,
				"text": "Unknown"
			},
			{
				"x": 53,
				"text": "<30<br>n=12"
			},
			{
				"x": 59,
				"text": "30-39<br>n=12"
			},
			{
				"x": 65,
				"text": "40-49<br>n=16"
			},
			{
				"x": 71,
				"text": ">=50<br>n=48"
			}
		],
		"dataTable": {
			"MSM:<30": [
				5,
				5,
				4,
				4,
				4,
				3
			],
			"MSM:30-39": [
				5,
				5,
				3,
				3,
				3,
				2
			],
			"MSM:40-49": [
				9,
				8,
				7,
				6,
				4,
				1
			],
			"MSM:>=50": [
				27,
				26,
				19,
				19,
				18,
				12
			],
			"Non-MSM:<30": [
				9,
				9,
				6,
				5,
				3,
				1
			],
			"Non-MSM:30-39": [
				25,
				25,
				20,
				20,
				17,
				5
			],
			"Non-MSM:40-49": [
				48,
				47,
				45,
				43,
				33,
				9
			],
			"Non-MSM:>=50": [
				92,
				92,
				81,
				78,
				75,
				38
			],
			"Unknown:<30": [
				12,
				6,
				5,
				5,
				5,
				1
			],
			"Unknown:30-39": [
				12,
				12,
				9,
				9,
				7,
				4
			],
			"Unknown:40-49": [
				16,
				15,
				12,
				11,
				8,
				6
			],
			"Unknown:>=50": [
				48,
				44,
				34,
				33,
				29,
				17
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_nha_5_5.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_nha_5_5.json
// module id = 272
// module chunks = 0